/**
 * Errors every NearSt frontend should drop before they reach Sentry.
 *
 * Seeded from the list shopping-service had accumulated, which was the only one
 * of the four frontends doing any filtering at all. Entries are grouped by why
 * they are noise — a bare list invites people to append to it without asking
 * whether the error is genuinely unactionable, which is how these lists rot.
 *
 * Rule of thumb: an entry belongs here only if NO change we could make to our
 * own code would prevent it. Anything we could fix belongs in Sentry, however
 * annoying.
 */

/** Browser layout quirks — fired by the platform, harmless, unfixable by us. */
const BROWSER_NOISE = [
	'ResizeObserver loop limit exceeded',
	'ResizeObserver loop completed with undelivered notifications',
	'Non-Error promise rejection captured'
];

/**
 * Network failures. These are the user's connection dropping, a tab being
 * closed mid-flight, or a corporate proxy — not a defect in our code. They are
 * also, by volume, the single largest source of unactionable frontend events.
 */
const NETWORK_NOISE = ['Load failed', 'Failed to fetch', 'NetworkError when attempting to fetch resource.', 'AbortError'];

/**
 * Injected third-party code: browser extensions, in-app webviews (Instagram,
 * Facebook, LinkedIn), and native bridges. We do not control any of it, and it
 * cannot be reproduced from our own build.
 */
const THIRD_PARTY_NOISE = [
	/Java object is gone/,
	/window\.webkit\.messageHandlers/,
	'_AutofillCallbackHandler',
	'runtime.sendMessage',
	"Cannot assign to read only property 'pushState'",
	'The operation is insecure',
	"Failed to read the 'localStorage' property from 'Window'"
];

/** Framework-internal churn that surfaces as an error but is recovered from. */
const FRAMEWORK_NOISE = ['Invariant: attempted to hard navigate to the same URL', /feature named .* was not found/];

/** Known-and-handled application paths that report through a UI state instead. */
const HANDLED_APPLICATION_NOISE = ['could not create user after'];

export const SHARED_IGNORE_ERRORS = Object.freeze([
	...BROWSER_NOISE,
	...NETWORK_NOISE,
	...THIRD_PARTY_NOISE,
	...FRAMEWORK_NOISE,
	...HANDLED_APPLICATION_NOISE
]);
